import React from "react";

const ControlRelayPanel = () => {
  return (
    <div className="bg-white text-gray-800 p-6 rounded-xl shadow-xl border border-emerald-200 w-full">
      <h3 className="text-2xl font-bold text-emerald-700 mb-4">
        Control and Relay Panel (Switchyard)
      </h3>
      <p className="mb-4">
        The switchyard is a crucial part of an electrical generation, transmission, and distribution system.
        Substations here transform voltage from high to low (or vice versa) and perform essential grid control functions.
      </p>
      <p className="mb-4">
        <strong>We are expert designers of Control and Relay Panels for:</strong>
      </p>
      <ul className="list-disc list-inside grid grid-cols-2 gap-x-10 mb-4">
        <li>400 kV</li>
        <li>220 kV</li>
        <li>132 kV</li>
        <li>66 kV</li>
      </ul>
      <p className="font-semibold mb-2">Our scope includes:</p>
      <ul className="list-disc list-inside space-y-2">
        <li>Study of single line diagram</li>
        <li>Preparation of schematic</li>
        <li>Preparation of descriptive table</li>
        <li>Preparation of outline general arrangement</li>
      </ul>
    </div>
  );
};

export default ControlRelayPanel;
